module.exports = __webpack_public_path__ + "exo-latin-200.ae44adae71863b09ecbc.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-200.woff
// module id = ../../../../typeface-exo/files/exo-latin-200.woff
// module chunks = styles